export default __webpack_public_path__ + "static/hram-prepodobnogo-sergiya-radonezhskogo_2-1ca68cbde4be9fd0634f4b6e1f394880.jpg";